export default __webpack_public_path__ + "static/media/Revealr_WhiteText.77c352cc.png";